import Tooltip from "@mui/material/Tooltip/Tooltip"
import Typography from "@mui/material/Typography/Typography"
import { useStore } from "@nanostores/react"

import { NumberFont } from "./RootLayout/fonts"
import { $usdCurrency } from "../stores/currency-store"
import { nativeTokenInfo } from "../utils/native-token"

import { useTokenPrices } from "@/api/portfolio-api"
import { formatNumberAuto } from "@/utils/format"
import { L1_AR } from "@/settings"

interface PriceDisplayProps {
  amount: number
  token?: string
  ticker?: string
  details?: boolean
  decimals?: number
  showOnlyUsd?: boolean
}

export function PriceDisplay(props: PriceDisplayProps) {
  const { amount, token, ticker, decimals = 2, showOnlyUsd = false } = props

  const [prices] = useTokenPrices()
  const tokenPrice = token ? prices?.[token]?.price : undefined
  const nativeTokenPrice = prices?.[L1_AR]?.price

  const useCurrency = useStore($usdCurrency)

  const displayValue = amount && token && tokenPrice ? amount * tokenPrice : amount

  if (useCurrency || showOnlyUsd) {
    return (
      <Typography fontFamily={NumberFont} component="span" variant="inherit">
        <Tooltip
          title={
            <Typography fontFamily={NumberFont} component="span" variant="inherit">
              {!token ? (
                <span>
                  {formatNumberAuto(amount)} {ticker}
                </span>
              ) : (
                <span>{displayValue} USD</span>
              )}
            </Typography>
          }
        >
          <span>${formatNumberAuto(displayValue, decimals)}</span>
        </Tooltip>
      </Typography>
    )
  }

  const valueInNativeToken = displayValue && nativeTokenPrice ? displayValue / nativeTokenPrice : 0

  return (
    <Typography fontFamily={NumberFont} component="span" variant="inherit">
      <Tooltip
        title={
          <Typography fontFamily={NumberFont} component="span" variant="inherit">
            <span>
              {valueInNativeToken} {nativeTokenInfo.ticker}
            </span>
          </Typography>
        }
      >
        <span>
          {formatNumberAuto(valueInNativeToken, valueInNativeToken < 10 ? 2 : decimals)}{" "}
          {nativeTokenInfo.ticker}
        </span>
      </Tooltip>
    </Typography>
  )
}
